import { differenceInDays, xhr, toast } from "$app/utils"
import { appStore } from "$app/store.svelte"

/**
 *
 * @param goal GoalType
 * @param today Date
 * @param last_meeting_date Date
 * @returns
 */
export function needsUpdate(
  goal: any,
  last_meeting_date: Date,
  today: Date
): boolean {
  if (["complete", "not_met"].includes(goal.status)) {
    return false
  }
  let created_at = goal.created_at
  if (typeof goal.created_at === "string") {
    created_at = new Date(`${goal.created_at.substr(0, 10)}T00:00:00`)
  }
  if (!goal.progress_date) {
    return differenceInDays(today, created_at) > 5
  }

  return differenceInDays(last_meeting_date, goal.progress_date) >= 1
}

export function isLeadership(role: string): boolean {
  return ["coach", "admin", "leader"].includes(role)
}

export async function deleteGoal(goal: GoalType): Promise<GoalType | null> {
  if (!confirm(`Are you sure you want to delete goal: ${goal.name}`)) return

  try {
    await xhr.delete(`/plans/${goal.plan_id}/goals/${goal.id}.json`)
    appStore.goals = appStore.goals.filter((g) => g.id !== goal.id)
    return goal
  } catch (e) {
    toast(`There was an error deleting goal: ${goal.name}`, "error")
  } finally {
    return null
  }
}
